var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "drawer-page" },
        [
          _c("div", { staticClass: "drawer-page-title" }, [
            _vm._v(_vm._s(_vm.$t("language.addEmail.connectDesc")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-page-body" },
            [
              _c("div", { staticClass: "add-txt" }, [
                _vm._v(_vm._s(_vm.$t("language.addEmail.peEmail")))
              ]),
              _vm._v(" "),
              _c(
                "el-scrollbar",
                { ref: "pageScrollbar", staticStyle: { height: "100%" } },
                [
                  _c(
                    "div",
                    { staticClass: "drawer-page-add-body" },
                    [
                      _vm._l(_vm.addEmailLine, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "drive-add-cloud",
                            on: {
                              click: function($event) {
                                return _vm.addEmailDialog(item)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "add-cloud-item" }, [
                              _c("div", { staticClass: "add-cloud-center" }, [
                                _c("div", {
                                  staticClass: "cloud cloud-size cloudPosition",
                                  class: item.appName
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "add-cloud-item-name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.addCloud." + item.appName
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "add-cloud-item-name add-cloud-item-name-coming",
                                  staticStyle: { padding: "0" }
                                })
                              ])
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(_vm.otherEmailLine, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "drive-add-cloud" },
                            [
                              _c("div", { staticClass: "add-cloud-item" }, [
                                _c("div", { staticClass: "add-cloud-center" }, [
                                  _c("div", {
                                    staticClass:
                                      "cloud cloud-size cloudPosition",
                                    class: item.icon
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "add-cloud-item-name" },
                                    [_vm._v(_vm._s(item.appName))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "add-cloud-item-name add-cloud-item-name-coming"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.addCloud.comingSoon")
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("addCloudDialog", { ref: "addCloudDialog" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66b87c08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b87c08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/drawer/page/add_email.vue
// module id = null
// module chunks = 